// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

export { PostOfficeConfluenceSideNavPlacement } from './ui/PostOfficeSideNav';
